/**
 * Shared Stripe Elements appearance, themed to match the app's light/dark
 * tokens. Used by every embedded checkout (coin packs + AI credits) so the
 * card form styling stays consistent in one place.
 */

export function getStripeAppearance(resolvedTheme: string | undefined) {
    const dark = resolvedTheme === "dark";
    return {
        theme: dark ? ("night" as const) : ("stripe" as const),
        variables: {
            colorPrimary: dark ? "#A29BFE" : "#6C5CE7",
            colorBackground: dark ? "#222240" : "#ffffff",
            colorText: dark ? "#E8E8EE" : "#2D3436",
            borderRadius: "8px",
            fontFamily: "Inter, sans-serif",
            colorDanger: dark ? "#FF6B6B" : "#D63031",
            spacingUnit: "4px",
        },
    };
}
